/**
 * Created by hp on 2017/6/6.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Cells, Cell, CellBody, CellFooter} from 'react-weui';

class LabelBar extends Component {
    render() {
        const {labelFoot, onCellClick, children, labelClassName, weuiModify} = this.props;

        return (
            <Cells className={"margin-top font-Set-Size_14 default-hover " + labelClassName + weuiModify}>
                <Cell access onClick={onCellClick}>
                    <CellBody style={{overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis'}}>{children}</CellBody>
                    <CellFooter>{labelFoot}</CellFooter>
                </Cell>
            </Cells>
        )
    }
}

export default connect(state => ({

}))(LabelBar)


// WEBPACK FOOTER //
// ./src/components/LabelBar.js